// components/GameWindow.js
import React from 'react';
import JackpotDisplay from './JackpotDisplay.js';
import Slots from './Slots.js'
import Controls from './Controls.js'
import { useGameContext } from '../GameContext';

import './gameWindow.css';

import grandJackpotImg from './assets/grand-jackpot.png';
import majorJackpotImg from './assets/major-jackpot.png';
import minorBonusImg from './assets/minor-bonus.png';
import miniBonusImg from './assets/mini-bonus.png';

function GameWindow() {
    const { gameState } = useGameContext();
    return (
        <div className="game-window">
            <div className='jackpot-displays'>
                <JackpotDisplay jackpot={gameState.grandJackpot} img={grandJackpotImg}/>
                <JackpotDisplay jackpot={gameState.majorJackpot} img={majorJackpotImg} />
                <JackpotDisplay jackpot={gameState.minorBonus} img={minorBonusImg} />
                <JackpotDisplay jackpot={gameState.miniBonus} img={miniBonusImg} />
            </div>
            <Slots></Slots>
            <Controls betAmount={gameState.currentBet}></Controls>
        </div>
    );
}

export default GameWindow;
